/**
 * videoMerge.ts — COMPATIBILITÉ DESCENDANTE
 * La vraie logique vit dans VideoEngine.ts
 */
import { VideoEngine, generateSubtitles as _genSubs, Subtitle } from './VideoEngine';

export type SubtitleCue = Subtitle;
export const generateSubtitles = _genSubs;

export interface MergeParams {
  pexelsVideoUrl: string;
  audioB64: string;
  thumbnailUrl?: string;
  script: string;
  produit?: string;
  onProgress?: (step: string, pct: number) => void;
}

export async function mergeAll(params: MergeParams): Promise<Blob> {
  const output = await VideoEngine.render({
    backgroundVideoUrl: params.pexelsVideoUrl,
    audioB64: params.audioB64,
    scriptForSubtitles: params.script,
    format: 'portrait',
    branding: {
      nom: params.produit || 'ContenuIA',
      couleur: '#6C47FF',
      afficherUrl: 'contenuia.pages.dev',
      position: 'top-left',
    },
    onProgress: params.onProgress,
  });
  return output.blob;
}
